export const SessionKey = {
  idtoken: 'bhq_quick_user_id_token',
  expires: 'bhq_quick_user_expires_at',
  atoken: 'bhq_quick_user_access_token',
  role: 'bhq_quick_user_user_role',
  admin_id: 'bhq_quick_user_admin_id',
  superadmin: 'bhq_quick_user_superadmin',
  organization_id: 'bhq_quick_user_organization',
  language: 'bhq_quick_user_language',
  score: 'bhq_quick_user_score',
  sub: 'bhq_quick_user_sub'
}

const sessionCheck = () => {
  if (!localStorage.getItem(SessionKey.idtoken) || localStorage.getItem(SessionKey.expires) < (new Date()).getTime()) {
    console.log('Token does not exist, or expired.')
    return false
  } else {
    return true
  }
}

const getToken = () => {
  return localStorage.getItem(SessionKey.idtoken)
}

const clearSessions = () => {
  localStorage.removeItem(SessionKey.idtoken)
  localStorage.removeItem(SessionKey.expires)
  localStorage.removeItem(SessionKey.atoken)
  localStorage.removeItem(SessionKey.role)
  localStorage.removeItem(SessionKey.admin_id)
  localStorage.removeItem(SessionKey.superadmin)
  localStorage.removeItem(SessionKey.sub)
  localStorage.removeItem(SessionKey.organization_id)
  localStorage.removeItem(SessionKey.language)
  localStorage.removeItem(SessionKey.score)
}

const saveSession = (key, value) => {
  if (Object.keys(SessionKey).find((akey) => SessionKey[akey] === key)) {
    localStorage.setItem(key, value)
  }
}

const removeSession = (key) => {
  localStorage.removeItem(key)
}

const getSessionValue = (key) => {
  if (Object.keys(SessionKey).find((akey) => SessionKey[akey] === key)) {
    return localStorage.getItem(key)
  }
  return undefined
}

export const SU = {
  getToken,
  sessionCheck,
  clearSessions,
  saveSession,
  getSessionValue,
  removeSession
}
